/*
 * Copyright (C) 2024-2025 BIRU
 *
 * This file is part of Tenzu.
 *
 * Tenzu is free software: you can redistribute it and/or modify it
 * under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 *
 * You can contact BIRU at ask@biru.sh
 *
 */

import { inject, Injectable } from "@angular/core";
import { WorkspaceRolesApiService } from "./workspace-roles-api.service";
import { ProjectRolesEntitiesSummaryStore, ProjectRolesDetailStore } from "./workspace-roles-entities.store";
import { BaseRepositoryService } from "../base";
import type * as WorkspaceRolesApiServiceType from "./workspace-roles-api.type";
import { WorkspaceRoleSummary, WorkspaceRoleDetail } from "./workspace-roles.model";

@Injectable({
  providedIn: "root",
})
export class WorkspaceRoleRepositoryService extends BaseRepositoryService<
  WorkspaceRoleSummary,
  WorkspaceRoleDetail,
  WorkspaceRolesApiServiceType.ListEntitiesSummaryParams,
  WorkspaceRolesApiServiceType.GetEntityDetailParams,
  WorkspaceRolesApiServiceType.CreateEntityDetailParams,
  WorkspaceRolesApiServiceType.PutEntityDetailParams,
  WorkspaceRolesApiServiceType.PatchEntityDetailParams,
  WorkspaceRolesApiServiceType.DeleteEntityDetailParams
> {
  protected apiService = inject(WorkspaceRolesApiService);
  protected entitiesSummaryStore = inject(ProjectRolesEntitiesSummaryStore);
  protected entityDetailStore = inject(ProjectRolesDetailStore);
  defaultRole = this.entitiesSummaryStore.defaultRole;
  ownerRole = this.entitiesSummaryStore.ownerRole;
}
